import React, { ReactNode, useState } from 'react';
import { FormModal } from 'components/molecules/Modal';
import { useTranslations } from 'hooks/useTranslations';

export interface IArchivedValueConfirm {
  confirmChange: (dropsArchivedValue: boolean, applyChange: () => void) => void;
  archivedConfirmModal: ReactNode;
}

export const useArchivedValueConfirm = (): IArchivedValueConfirm => {
  const { t } = useTranslations();
  const [pendingChange, setPendingChange] = useState<{ apply: () => void } | null>(null);

  const confirmChange = (dropsArchivedValue: boolean, applyChange: () => void) => {
    if (!dropsArchivedValue) {
      applyChange();
      return;
    }
    setPendingChange({ apply: applyChange });
  };

  const archivedConfirmModal = pendingChange ? (
    <FormModal
      open
      onClickClose={() => setPendingChange(null)}
      onClickApprove={() => {
        pendingChange.apply();
        setPendingChange(null);
      }}
      approveButtonLabel="general.yes.label"
      cancelButtonLabel="general.no.label"
      title={t('dictionary.archivedValue.confirm.title')}
      text={t('dictionary.archivedValue.confirm.text')}
    />
  ) : null;

  return { confirmChange, archivedConfirmModal };
};
